module.exports = __webpack_public_path__ + "img/logo.79dc1879.svg";